import React, { useState } from 'react';
import './App.css';
import RegistrationForm from './RegistrationForm';
import img from './images/img.jpg';

function App() {
  const [showForm, setShowForm] = useState(false);

  const handleRegisterClick = (e) => {
    e.preventDefault(); 
    setShowForm(true);
  };

  return (
    <div className="app" style={{display :'flex'}}>
      <section className='first-layer'>
        <div className='img-form'>
          <img className='img' src={img} alt="immagine" />
      </div>
          </section>
          <section className='second-layer'>  
            <div className='form'>
              <div className='items'>
                <div>
              <h1 className='item0'>Nuovo e gratis: </h1>
              <h2 className='item1'> investi nelle tue competenze!</h2>
              </div>
              <br></br>
              <div>
              {!showForm ? ( 
            <button className='item2' href="registrati" onClick={handleRegisterClick}>
              Chiedi informazioni 
            </button>
          ) : ( 
            <RegistrationForm />
          )}
              </div>
              </div>
            </div>
   
   </section>

    </div>
  );
}

export default App;
